import { memo, useEffect, useMemo, useState } from 'react';
import './index.scss';
import { useKeenSlider } from 'keen-slider/react';
import Arrow from '@components/Carousel/components/Arrow';
import { twcls } from '@utils/twcls';

const WeightTabs = ({
  onChangeWeightTabHandler,
  variants,
  variantInfoId,
  isDesktop
}) => {
  const [loaded, setLoaded] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderRef, instanceRef] = useKeenSlider({
    rubberband: false,
    loop: false,
    mode: 'free-snap',
    selector: '.weight-tabs-slide',
    slides: {
      perView: 'auto',
      spacing: 4
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    }
  });
  useEffect(() => {
    instanceRef.current?.update();
  }, [variants, instanceRef, variantInfoId]);
  const onTabClickHandler = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    onChangeWeightTabHandler(id);
  };
  const onLeftArrowClick = e => {
    e.preventDefault();
    e.stopPropagation();
    instanceRef.current?.prev();
  };
  const onRightArrowClick = e => {
    e.preventDefault();
    e.stopPropagation();
    instanceRef.current?.next();
  };
  const filteredList = useMemo(
    () =>
      variants.filter(variant => variant.id && variant?.sizeRangeItem?.title),
    [variants]
  );
  if (!filteredList?.length) {
    return null;
  }
  return (
    <div className='weight-tabs'>
      <div ref={sliderRef} className='keen-slider'>
        {filteredList.map((variant, index) => {
          const isTabActive = variant?.id === variantInfoId;
          return (
            <div
              key={variant.id}
              onClick={e => onTabClickHandler(e, variant?.id)}
              className={twcls(
                'weight-tabs-slide weight-tab',
                isTabActive && 'weight-tab--active',
                index === filteredList.length - 1 && 'weight-tab--last'
              )}
            >
              {variant.sizeRangeItem.title}
            </div>
          );
        })}
      </div>
      {loaded && instanceRef.current && currentSlide !== 0 && (
        <Arrow
          height={isDesktop ? '26' : '20'}
          className='weight-tabs__arrow weight-tabs__arrow--left'
          onClick={onLeftArrowClick}
          left
          instanceRef={instanceRef}
          currentSlide={currentSlide}
        />
      )}
      {loaded &&
        instanceRef.current &&
        currentSlide !== instanceRef?.current?.track?.details?.maxIdx && (
          <Arrow
            height={isDesktop ? '26' : '20'}
            className='weight-tabs__arrow'
            onClick={onRightArrowClick}
            right
            instanceRef={instanceRef}
            currentSlide={currentSlide}
          />
        )}
    </div>
  );
};

export default memo(WeightTabs);
